import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon GroupReviewIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const GroupReviewIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 16 16">
      <circle cx={8} cy={8} r={7.5} stroke="#F7A703" />
      <path
        d="M7.18066 8.46079C7.18066 7.62648 7.85701 6.95013 8.69132 6.95013H11.0605C11.8948 6.95013 12.5711 7.62648 12.5711 8.46079C12.5711 9.2951 11.8948 9.97145 11.0605 9.97145H10.1146"
        stroke="#F7A703"
        strokeLinecap="round"
      />
      <path
        d="M9.09668 8.50723C8.96385 9.37082 8.20987 10.0011 7.33641 9.9787L4.91819 9.91667C4.08873 9.8954 3.42739 9.21688 3.42739 8.38714C3.42739 7.54213 4.1124 6.85712 4.95741 6.85711L5.71387 6.8571"
        stroke="#F7A703"
        strokeLinecap="round"
      />
    </Icon>
  )
}
export default GroupReviewIcon
